import { initializeApp } from "firebase/app";

const firebaseConfig = {
	apiKey: "AIzaSyCHIi-cDpiT6CEHmfvQ_R9ID18y8SLat5U",
	authDomain: "netcometanlise-6bb3d.firebaseapp.com",
	databaseURL: "https://netcometanlise-6bb3d.firebaseio.com",
	projectId: "netcometanlise-6bb3d",
	storageBucket: "netcometanlise-6bb3d.appspot.com",
	messagingSenderId: "781297039882",
	appId: "1:781297039882:web:90668fe1c8387a9b457df3",
};

const app = initializeApp(firebaseConfig);

export default app;
